import { captureEvent } from '../metrics/captureEvent'
import { saveOfferClick } from '../middleware/saveOfferClick'
import { pageview, event } from './ga4'

/**
 * send downsell click event to GA
 * @param {string} offer - offer slug
 * @param {string} type - offer type
 * @param {boolean} hasDailyCap - whether offer has daily cap
 * @return {Promise<void>}
 */
export const handleDownsellClick = async (
  offer,
  type = 'downsell_offer_click',
  hasDailyCap = false,
) => {
  if (typeof window !== 'undefined') {
    event({
      action: type,
      params: {
        offer_name: offer,
      },
    })

    captureEvent('offer-clicked', { offer, type })

    const page = `${type.replace(/_/g, '-')}-${offer}`

    pageview(page)

    if (hasDailyCap) {
      await saveOfferClick(offer)
    }
  }
}
